/****************************************************************************************
 * File Name    : Tools.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="24">
                <div class="gutter-box">
                    <PageHeader title = "치공구 외 보고서 관리" />
                </div>
            </a-col>
            <!-- <a-col class="gutter-row" :span="12">
                <div class="gutter-box div_action">
                    <span class = 'icon_button' @click="showDrawer">
                        <a-tag color="#2980B9">
                            <a-icon type="plus-circle" /> 신규 치공구 계측기
                        </a-tag>
                    </span>
                </div>
            </a-col> -->
        </a-row>
        <a-divider type = 'horizontal' />
        <!-- <a-row type="flex" justify="center" align="top" :gutter="8" v-if = "1===2">
            <a-col :span="24">
                <Tool name = "토오크" type = "list" :description = "['에어','전기','기타']" v-on:editTool="editTool" v-on:deleteTool="deleteTool"/>
            </a-col>
        </a-row> -->
        <p/>
        <a-drawer title="" placement="right" width="100%" :closable="false" :visible="flagForDrawer" :get-container="false" @close="closeDrawer" >
            <ToolReportViewer :selectedTool="selectedTool" v-on:flagForDrawer="closeDrawer" v-on:editToolInfo="editToolInfo" />
        </a-drawer>
        <!-- <a-space align="end">
            <a-radio-group style = ''>
                <a-radio-button value="전체">전체</a-radio-button>
                <a-radio-button value="토오크">토오크</a-radio-button>
                <a-radio-button value="가스세이버">가스세이버</a-radio-button>
                <a-radio-button value="냉매 차징기">냉매 차징기</a-radio-button>
                <a-radio-button value="내전압 시험기">내전압 시험기</a-radio-button>
                <a-radio-button value="접지 연속성 시험기">접지 연속성 시험기</a-radio-button>
                <a-radio-button value="질소 검사">질소 검사</a-radio-button>
                <a-radio-button value="진공 검사">진공 검사</a-radio-button>
                <a-radio-button value="전류 검사">전류 검사</a-radio-button>
                <a-radio-button value="특기 사항">특기 사항</a-radio-button>
            </a-radio-group>
        </a-space> -->
        <p/>
        <div class = 'todo'>구분별 관리자별 필터, 이름검색</div>

        <a-space align="end">
            일자 조회
            <date-picker v-model="filterDateStartCS" valueType="format" v-on:change="filterCSList" style="width:120px;"></date-picker> ~
            <date-picker v-model="filterDateEndCS" valueType="format" v-on:change="filterCSList" style="width:120px;"></date-picker>
        </a-space>

        <p />

        <a-table :columns="columns" size = "small" :bordered=false :data-source="data" :pagination="true" :scroll="{ x: 0, y: '100vh' }">
            <span slot="valid" slot-scope="valid">
                <a-tag class="state-btn" :class="{ green: (valid === 'B'), navy: (valid === 'C') }">
                    {{ valid === 'B' ? '검사완료' : '승인완료' }}
                </a-tag>
            </span>
            <span slot="action" slot-scope="record">
                <!-- <span @click = "addEquipmentControl"><a-icon type="plus" /> Add</span>
                <a-divider type="vertical" /> -->
                <span style = 'cursor:pointer' @click = "editTool(record)"><a-icon type="eye" /> View</span>
                <a-divider type="vertical" />
                <span style = 'cursor:pointer' @click = "deleteTool(record)"><a-icon type="delete" /> Delete</span>
            </span>
        </a-table>
        <p/>
    </div>
</template>
<script>
const columns = [
    {    title: '상태', dataIndex: 'valid'         ,   key: 'valid'   ,  scopedSlots: { customRender: 'valid'      },},
    {    title: '라인'    ,   dataIndex: 'etc'       ,   key: 'etc'      ,  scopedSlots: { customRender: 'etc'          }, },
    {    title: '최종수정일'    ,   dataIndex: 'updated2'     ,   key: 'updated2'     ,  scopedSlots: { customRender: 'updated2'          },              },
    {    title: '관리'                              ,   key: 'action'   ,  scopedSlots: { customRender: 'action'        },  width : 250 },
];

import _ from "lodash";
import DatePicker from 'vue2-datepicker';

import PageHeader      from "../components/PageHeader.vue";
// import Tool            from "../components/Tool.vue"      ;
import ToolReportViewer        from "./ToolReportViewer.vue"  ;
export default {
    name: 'ToolReport',
    components: {
        PageHeader      ,
        DatePicker,
        // Tool           ,
        ToolReportViewer
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            data : [],
            dataBackup: [],
            filterCS : '',
            filterField: '모델명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            columns,
            selectedTool: {},
            selectedToolTemplate: {"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-03-02 15:10:24","toolInspectionSeq":0,"inspectionBeginDate":"2022-03-02 15:05:24","inspectionEndDate":"2022-03-02 15:10:24","clsEquipmentLineInfo":{"valid":"V","creator":null,"created":"2022-02-22 19:37:44","updater":null,"updated":"2022-02-22 10:37:44","equipmentLineInfoSeq":9,"lineName":"청정기 1 line","targetProduct":"airpurifier","manager":"line2점검자","admin1":"관리자1 2","admin2":"관리자2 2","beginDate":"2022-02-22 10:37:44","endDate":"9999-12-31 00:00:00"},"modelName":"Model","listTorque":[{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":3,"inspectionIndex":0,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":20,"inspectionIndex":1,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":21,"inspectionIndex":2,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":3,"inspectionIndex":0,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":20,"inspectionIndex":1,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":21,"inspectionIndex":2,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":3,"inspectionIndex":0,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":20,"inspectionIndex":1,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":21,"inspectionIndex":2,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":3,"inspectionIndex":0,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":20,"inspectionIndex":1,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""},{"valid":"V","creator":null,"created":"2022-02-25 18:33:32","updater":null,"updated":"2022-02-25 09:36:31","toolInspectionTorqueSeq":21,"inspectionIndex":2,"processName":"","toolKind":"ToolKind","adminNo":"","value":"","tester":"","exchangeNo":"","etc":""}],"clsGasSaver":{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 08:52:19","toolInspectionGasSaverSeq":2,"manageNo":"","lpg":"","oxygen":"","weldingStatus":"WeldingStatus","ignitionStatus":"수정2","fluxStatus":"FluxStatus"},"clsRefrigerantCharger":{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 02:12:37","toolInspectionRefrigerantChargerSeq":2,"freonPressure":"","vaccum":"","freonTemp":"","setting":"","fillingAmount":"","sofwareStatus":"SofwareStatus"},"clsHipotTester":{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 02:12:37","toolInspectionHipotTesterSeq":2,"hipotSetting":"","insulationResistanceSetting":"","indicatorStatus":"IndicatorStatus","sofwareStatus":"SofwareStatus"},"clsEarthTester":{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 02:12:37","toolInspectionEarthTesterSeq":2,"currentSetting":"","timeSetting":"","indicatorStatus":"IndicatorStatus","sofwareStatus":"SofwareStatus"},"clsNitrogen":{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 02:12:37","toolInspectionNitorgenSeq":2,"pressure":"","stabilizationTime":"","inspectionTime":"","psi":"","touchPanelStatus":"TouchPanelStatus","gaugeStatus":"GaugeStatus","sofwareStatus":"SofwareStatus"},"clsVacuum":{"valid":"V","creator":null,"created":"2022-02-25 11:12:38","updater":null,"updated":"2022-02-25 02:12:38","toolInspectionVacuumSeq":2,"injectionTime":"","stabilizationTime":"","inspectionTime":"","psi":"","touchPanelStatus":"TouchPanelStatus","gaugeStatus":"GaugeStatus","sofwareStatus":"SofwareStatus"},"clsCurrent":{"valid":"V","creator":null,"created":"2022-02-25 11:12:37","updater":null,"updated":"2022-02-25 02:12:37","toolInspectionCurrentSeq":2,"currentSetting":"","touchPanelStatus":"TouchPanelStatus"},"etc":"","no":1}
        };
    },
    mounted() {
        this.loadList();
    },
    methods : {
        editToolInfo() {
            this.flagForDrawer = false;
            this.loadList();
        },
        loadList() {
            this.flagForSpinner = true;
            this.data = [];
            let urlToFetchProducts = this.$store.state.hostInService + "/tool/inspection";
            this.$http.get(urlToFetchProducts)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    let dataArray = response.data.data.content;
                    dataArray = dataArray.reverse();    // 최종생성된 것이 위로 가도록 정렬
                    dataArray = _.orderBy(dataArray, ['updated2'], ['desc']);  // 수정 날짜 최신순 정렬
                    for(let x = 0; x < dataArray.length; x ++ ) {
                        dataArray[x].no = x + 1;
                        dataArray[x].state = '작성완료';

                        if (dataArray[x].valid === 'B' || dataArray[x].valid === 'C') { // 검사완료, 승인완료
                            this.data.push(dataArray[x]);
                        }
                    }

                    this.data = _.orderBy(this.data, ['valid', 'updated2'], ['asc', 'desc']);
                    this.dataBackup = JSON.parse(JSON.stringify(this.data));
                }
                this.flagForSpinner = false;

            }).catch(error => {
                console.log(error);
                this.flagForSpinner = false;
            });
        },
        showDrawer() {
            this.flagForDrawer = true;
        },
        closeDrawer() {
            this.flagForDrawer = false;
        },
        createTool() {
            this.selectedTool = JSON.parse(JSON.stringify(this.selectedToolTemplate));
            this.flagForDrawer = true;
        },
        editTool(record) {
            this.selectedTool = record;
            this.flagForDrawer = true;
        },
        deleteTool(record) {
            if (confirm('삭제하시겠습니까?')) {
                let apiUrl = this.$store.state.hostInService + "/tool/inspection/delete/" + record.toolInspectionSeq;
                this.$http.put(apiUrl)
                .then((response) => {
                    console.log(response);
                    if(response.status === 200 && response.data.code === 'success') {
                        this.buffer = response.data.data;
                    }
                    this.$message.success("삭제되었습니다.");
                    this.loadList();
                })
                .catch(error => {
                    console.log(error);
                    this.$message.error("삭제되지 않았습니다.");
                });
            }
        },
        filterCSList() {
            if (this.filterCS || this.filterDateStartCS || this.filterDateEndCS) {
                let tempData = _.cloneDeep(this.dataBackup);

                if (this.filterCS) {
                    let re = new RegExp(this.filterCS, 'gi');

                    tempData = _.filter(tempData, (item) => {
                        // 모델명
                        if (this.filterField === '모델명') {
                            return item.model && item.model.match(re) || item.modelDetail && item.modelDetail.match(re);
                        }
                        // 제품명
                        else if (this.filterField === '제품명') {
                            return item.product && item.product.match(re);
                        }
                    });
                }

                if (this.filterDateStartCS) {
                    try {
                        let startTime = (new Date(this.filterDateStartCS)).getTime();
                        tempData = _.filter(tempData, (item) => {
                            return (new Date(item.updated)).getTime() >= startTime;
                        });
                    } catch (e) {
                        console.log(e)
                    }
                }

                if (this.filterDateEndCS) {
                    try {
                        let endTime = (new Date(this.filterDateEndCS)).getTime() + 86400000;
                        tempData = _.filter(tempData, (item) => {
                            return (new Date(item.updated)).getTime() <= endTime;
                        });
                    } catch (e) {
                        console.log(e)
                    }
                }

                this.data = tempData;
            } else {
                this.data = this.dataBackup;
            }
        }
    }
}
</script>
<style scoped>
</style>